import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { User, UserDTO } from '../interfaces/userinfo.response.dto';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  baseUrl: string = environment.apiUrl;

  private userSubject = new BehaviorSubject<UserDTO | null>(null);
  user$ = this.userSubject.asObservable();

  constructor(private http: HttpClient) {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      this.userSubject.next(JSON.parse(storedUser));
    }
  }

  updateUser(user: UserDTO): void {
    localStorage.setItem('user', JSON.stringify(user));
    this.userSubject.next(user);
  }
  getUserById(userId: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/users/${userId}`);
  }
  editUser(user: User): Observable<User> {
    return this.http.put<User>(`${this.baseUrl}/users/${user.id}`, {
      ...user,
    });
  }
  profilePasswordChange(userId?: string, body?: any): Observable<any> {
    return this.http.put<any>(
      `${this.baseUrl}/users/${userId}/change-password`,
      body
    );
  }
  get2FA(userId: string): Observable<any> {
    return this.http.put<any>(
      `${this.baseUrl}/agencies/users/${userId}/get-secret`,
      {}
    );
  }
  verify2FA(userId: string, code: string): Observable<any> {
    return this.http.put<any>(
      `${this.baseUrl}/users/${userId}/enabled-2fa?code=${code}`,
      {}
    );
  }

  disabled2FA(userId: string, code?: string): Observable<any> {
    return code
      ? this.http.put<any>(
          `${this.baseUrl}/auth/users/${userId}/disable-2fa?code=${code}`,
          {}
        )
      : this.http.put<any>(
          `${this.baseUrl}/auth/users/${userId}/disable-2fa`,
          {}
        );
  }
}
